export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const demo_URL = process.env.REACT_APP_DEMO_URL;
export const MapLink=process.env.REACT_APP_MAP_KEY;